/* eslint-disable */
export default {
  ringing: '呼入电话',
  callConnected: '呼叫已接通',
} as const;

// @key: @#@"ringing"@#@ @source: @#@"Incoming call"@#@
// @key: @#@"callConnected"@#@ @source: @#@"Call connected"@#@
